import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {MaterialReactTable} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import JobMetricOrganizationService from "../../../../../API/orders/job/JobMetricOrganizationService";
import {Dialog, DialogActions, DialogContent, DialogTitle, Step, StepLabel, Stepper} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import BasicModelEstimateTableItem from "../estimate/BasicModelEstimateTableItem";
import JobMetricOrganizationTable from "../../prodaction/jobmetricorganization/JobMetricOrganizationTable";
import TextFieldValidation from "../../customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import ButtonBack from "../../../button/ButtonBack";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import ButtonCreate from "../../../button/ButtonCreate";
import ModelJobMetricOrderService from "../../../../../API/model-estimate/estimate/ModelJobMetricOrder";
import {useLocation} from "react-router-dom";
import {calcFilterData} from "../../../../../utils/common/calcFilterData";
import {JobMetricOrganizationFilterData} from "../../../../../data/FilterTables/JobMetricOrganizationFilterData";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import OrderUtil from "../../../../../utils/orders/OrderUtil";
import {orderJobType} from "../../../../../data/OrderJobType";

const ModelProductionCosts = ({
                                  data,
                                  setData,
                                  tableOptions,
                                  tableOptionsHandle,
                                  materials,
                                  listUnits,
                                  handleModalAlert,
                                  calcData
                              }) => {
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const columns = useMemo(
        () => [
            {
                id: "materialName",
                header: 'Материал',
                accessorKey: 'materialName',
                enableEditing: false,
                enableGrouping: true,
                minSize: 35,
            },
            {
                header: 'Наименование операции',
                accessorKey: 'jobMetricOrganizationName',
                enableEditing: false,
                enableGrouping: true,
                minSize: 35,
            },
            {
                header: 'Ед.изм.',
                accessorKey: 'unitName',
                enableColumnActions: false,
                enableEditing: false,
                size: 8,
            },
            {
                header: 'Объем',
                accessorKey: 'quantity',
                enableColumnActions: false,
                enableEditing: false,
                minSize: 50,
            },
        ],
        [data, setData],
    );
    const handleSubmit = (materialEstimateUnitId, value, onClose) => {
        ModelJobMetricOrderService.create(materialEstimateUnitId, value)
            .then(function (response) {
                const newData = materials.map(el => el.id === materialEstimateUnitId ? {
                    ...el,
                    jobMetricOrderOrganizations: [...el.jobMetricOrderOrganizations, response.data]
                } : el)
                calcData(newData)
                onClose()
                handleModalAlert("Данные изменены", 'success')
            }).catch(function (error) {
            handleModalAlert(error);
        })
    }
    const handleUpdate = (value, onClose) => {
        ModelJobMetricOrderService.update(currentEditRowData.id, value)
            .then(function (response) {
                const newData = materials.map(el => {
                    if (el.id === currentEditRowData.material) {
                        const jobMetricOrderOrganizations = el.jobMetricOrderOrganizations.map(el => el.id === currentEditRowData.id ? response.data : el)
                        return {...el, jobMetricOrderOrganizations}
                    } else {
                        return el
                    }
                })
                calcData(newData)
                setCreateModalOpen(false)
                handleModalAlert("Данные изменены", 'success')
            }).catch(function (error) {
            handleModalAlert(error);
        })
    }
    const handleDeleteRow = useCallback(
        (row) => {
            ModelJobMetricOrderService.delete(row.id)
                .then(function () {
                    const newData = materials.map(el => {
                        if (el.id === row.material) {
                            const jobMetricOrderOrganizations = el.jobMetricOrderOrganizations.filter(el => el.id !== row.id)
                            return {...el, jobMetricOrderOrganizations}
                        } else {
                            return el
                        }
                    })
                    calcData(newData)
                    setCreateModalOpen(false)
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [data],
    );
    const handleUpdateModel = (row) => {
        setCurrentEditRowData(row);
        setCreateModalOpen(true);
    }

    const menuItem = [
        {type: "edit", text: "Изменить", handler: handleUpdateModel},
        {type: "delete", text: "Удалить", handler: handleDeleteRow},
    ]

    return (
        <div>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", gap: "10px", paddingBottom: "30px"}}
            >
                <ButtonCreate
                    text={"Создать"}
                    width={130}
                    onClick={() => setCreateModalOpen(true)}
                />
            </Box>
            <MaterialReactTable
                selectAllMode={"all"}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        },
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                muiToolbarAlertBannerProps={{
                    sx: {
                        backgroundColor: (theme) => theme.palette.primary.light,
                    }
                }}
                columns={columns}
                data={data}
                rowHeight={13}
                columnSpacing={1}
                enableExpanding={true}
                enableGrouping={true}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                rowCount={tableOptions.totalElements}
                state={{showGlobalFilter: true, pagination: tableOptions,}}
                initialState={{
                    expanded: true,
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    grouping: ['materialName'],
                }}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
                enableRowActions={true}
                enableToolbarInternalActions={false}
                getRowId={(originalRow) => originalRow.id}
                localization={MRT_Localization_RU}
            />
            {createModalOpen && <CreateJobMetricModal
                open={createModalOpen}
                handleClose={() => setCreateModalOpen(false)}
                handleSubmit={currentEditRowData ? handleUpdate : handleSubmit}
                handleModalAlert={handleModalAlert}
                materials={materials}
                listUnits={listUnits}
                initValue={currentEditRowData}
            />}
        </div>
    );
};
const CreateJobMetricModal = ({open, handleClose, handleSubmit, handleModalAlert, materials, listUnits, initValue}) => {
    const pathname = useLocation().pathname
    const [activeStep, setActiveStep] = useState(0)
    const [selectedString, setSelectedString] = useState({})
    const [dataJobMetricOrganization, setDataJobMetricOrganization] = useState([]);
    const [selectedJob, setSelectedJob] = useState({})
    const [formState, setFormState] = useState({
        "unitName": listUnits[0].name,
        "quantity": ""
    })
    const [filteredData, setFilteredData] = useState([])
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [typeList, setTypeList] = useState([]);

    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, JobMetricOrganizationFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [JobMetricOrganizationFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`${pathname}-modal`, "searchQuery", searchQuery)
            }
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}-modal`]?.pageSize
        const searchQuery = pagesData[`${pathname}-modal`]?.searchQuery

        return {searchQuery, pageSize}
    }
    useEffect(() => {
        if (initValue) {
            setFormState({
                "unitName": initValue.unitName,
                "quantity": initValue.quantity
            })
            setActiveStep(2)
        } else {
            const {searchQuery, pageSize} = getStartPageSize()
            JobMetricOrganizationService.getAllJobMetricOrganizationForSettings()
                .then(function (response) {
                    const data = response.data.filter(el => el.added === true)
                    setFormState(prev => ({...prev, jobMetricOrganizationName: data[0]?.id}))
                    setDataJobMetricOrganization(data)
                    handleSearchQuery(searchQuery, data, pageSize)
                    setTypeList(OrderUtil.getListFieldByEnum(data, 'orderJobType', orderJobType));
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        }

    }, [])

    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalElements: materials.length,
        searchData: ""
    })
    const onClose = () => {
        handleClose()
        setActiveStep(0)
        setSelectedString({})
        setSelectedJob({})
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }

    const onBack = () => {
        if (activeStep === 1) {
            setTableOptions((prev) => ({...prev, totalElements: materials.length}))
        }
        setActiveStep(activeStep - 1)
    }

    const submit = () => {
        if (activeStep === 0) {
            setTableOptions((prev) => ({...prev, totalElements: dataJobMetricOrganization.length}))
            setActiveStep(1)
        } else if (activeStep === 1) {
            setActiveStep(2)
        } else {
            initValue ?
                handleSubmit({
                    "unitName": formState.unitName,
                    "quantity": formState.quantity,
                }, onClose)
                : handleSubmit(selectedString?.id, {
                    "jobMetricOrganizationName": selectedJob.metricName,
                    "unitName": formState.unitName,
                    "quantity": formState.quantity,
                }, onClose)
        }
    }

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${initValue ? "500px" : activeStep === 0 ? "1520px" : activeStep === 1 ? "950px" : "950px"}`,
                height: `${initValue ? "370px" : activeStep === 0 ? "920px" : activeStep === 1 ? "1000px" : "600px"}`,
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: initValue ? 20 : 40,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>{initValue ? "Редактировать работу" : "Добавить работу"}</DialogTitle>
                {!initValue && <Stepper
                    activeStep={activeStep}
                    style={{width: "600px"}}>
                    {["Материал", "Операция", "Параметры"].map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            {!initValue && <Box sx={{
                height: "32px",
                padding: "4px 0 4px 14px",
                fontSize: "18px",
                margin: "0px 40px 0 40px",
                display: "flex",
                alignItems: "center",
                borderRadius: "4px",
                border: selectedString?.id ? "#3B8BEC 1px solid" : "transparent 1px solid",
                '& .MuiTypography-root': {
                    fontWeight: (theme) => theme.typography.fontWeight,
                    color: (theme) => theme.palette.text.main,
                    '&:first-of-type': {
                        marginRight: '10px'
                    }
                },
            }}>
                <Typography component="p">{selectedString?.tempName}</Typography>
            </Box>}
            {activeStep !== 0 && selectedJob?.id && <Box sx={{
                height: "32px",
                padding: "4px 0 4px 14px",
                fontSize: "18px",
                border: selectedJob?.id ? "#3B8BEC 1px solid" : "transparent 1px solid",
                borderRadius: "4px",
                display: "flex",
                margin: "25px 40px 0px 40px",
                alignItems: "center",
                '& .MuiTypography-root': {
                    fontWeight: (theme) => theme.typography.fontWeight,
                    color: (theme) => theme.palette.text.main,
                    '&:first-of-type': {
                        marginRight: '10px'
                    }
                },
            }}>
                <Typography
                    component="p">{selectedJob?.metricName}
                </Typography>
            </Box>}
            <DialogContent sx={{padding: "20px 40px"}}>
                {activeStep === 0 ?
                    <BasicModelEstimateTableItem
                        selectedStringId={selectedString?.id}
                        setSelectedString={setSelectedString}
                        modal={true}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        data={materials}
                        handleModalAlert={handleModalAlert}
                    /> : activeStep === 1
                        ?
                        <Box
                            style={{width: "100%"}}
                        >
                            <JobMetricOrganizationTable
                                data={dataJobMetricOrganization}
                                isModal={true}
                                onlyName={true}
                                columnAdded={false}
                                selectedString={selectedJob}
                                setSelectedString={setSelectedJob}
                                tableOptions={tableOptions}
                                tableOptionsHandle={tableOptionsHandle}
                                handleModalAlert={handleModalAlert}
                                globalFilter={globalFilter}
                                handleSearchQuery={handleSearchQuery}
                                filteredData={filteredData}
                                columnsFilter={columnsFilter}
                                typeList={typeList}/>
                        </Box> :
                        <Box>
                            <TextFieldValidation
                                select
                                name="unitName"
                                label="Ед. изм."
                                value={formState.unitName}
                                setCurrValues={setFormState}
                            >
                                {listUnits.map((option) => (
                                    <MenuItem key={option.name} value={option.name}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextFieldValidation>
                            <TextFieldValidation
                                name="quantity"
                                label="Количество"
                                value={formState.quantity}
                                setCurrValues={setFormState}
                            >
                            </TextFieldValidation>
                        </Box>}
            </DialogContent>
            <DialogActions style={{padding: initValue ? 20 : 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 && !initValue && <ButtonBack text={"Назад"} onClick={onBack}/>} </Box>
                <Box>
                    <ButtonExit
                        text={"Выйти"} onClick={onClose}/>
                    <ButtonAdd
                        text={"Выбрать"} onClick={submit}
                        disabled={(activeStep === 0 && !selectedString?.id) || (activeStep === 1 && !selectedJob?.id)}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export default ModelProductionCosts;